export default {
	NUTRITION_CATEGORIES: 'Nutrition categories'
};